import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-697cdc8e")

_pushScopeId("data-v-697cdc8e")
const _hoisted_1 = {
  class: "h-50 flex justify-between items-center nav-map text-white px-30p",
  style: {"background-color":"#20AFEC"}
}
const _hoisted_2 = { class: "w-256 search flex items-center ml-284p" }
const _hoisted_3 = {
  key: 0,
  style: {"max-height":"288px","width":"320px","top":"44px"},
  class: "px-8p py-8p scrollbar--transparent overflow-y-auto rounded shadow-1p bg-white text-14 absolute"
}
const _hoisted_4 = { class: "flex items-center w-full break-words text-14 justify-between" }
const _hoisted_5 = { class: "whitespace-nowrap overflow-hidden flex items-center flex-1 min-w-0" }
const _hoisted_6 = { class: "text-left flex flex-col ml-16p truncate" }
const _hoisted_7 = { class: "truncate text-14p font-normal text-neutrals-900" }
const _hoisted_8 = { class: "flex items-center pl-30p text-14 h-full" }
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  class: "text-white icon-svg fill-current text-black"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M13.4922 13.0176C13.4375 13.0723 13.4375 13.127 13.4375 13.1816V16.2715H3.8125V6.64648H10.4023C10.457 6.64648 10.5117 6.64648 10.5664 6.5918L11.4414 5.7168C11.5781 5.58008 11.4688 5.33398 11.2773 5.33398H3.8125C3.07422 5.33398 2.5 5.93555 2.5 6.64648V16.2715C2.5 17.0098 3.07422 17.584 3.8125 17.584H13.4375C14.1484 17.584 14.75 17.0098 14.75 16.2715V12.3066C14.75 12.1152 14.5039 12.0059 14.3672 12.1426L13.4922 13.0176ZM17.7578 7.52148C18.3867 6.89258 18.3867 5.88086 17.7578 5.25195L16.582 4.07617C15.9531 3.44727 14.9414 3.44727 14.3125 4.07617L7.14844 11.2402L6.875 13.7285C6.79297 14.4395 7.39453 15.041 8.10547 14.959L10.5938 14.6855L17.7578 7.52148ZM15.0781 8.3418L9.99219 13.4277L8.1875 13.6465L8.40625 11.8418L13.4922 6.75586L15.0781 8.3418ZM16.8281 6.18164C16.9648 6.29102 16.9648 6.45508 16.8555 6.5918L16.0078 7.43945L14.4219 5.82617L15.2422 5.00586C15.3516 4.86914 15.543 4.86914 15.6523 5.00586L16.8281 6.18164Z" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon-svg fill-current text-white"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M14.6719 14H16.043C16.2539 14 16.5 13.7891 16.5 13.5781V8.83203C16.5 8.62109 16.2539 8.375 16.043 8.375H14.6719C14.4609 8.375 14.25 8.62109 14.25 8.83203V13.5781C14.25 13.7891 14.4609 14 14.6719 14ZM18.0469 14H19.418C19.6289 14 19.875 13.7891 19.875 13.5781V5.45703C19.875 5.24609 19.6289 5 19.418 5H18.0469C17.8359 5 17.625 5.24609 17.625 5.45703V13.5781C17.625 13.7891 17.8359 14 18.0469 14ZM7.92188 14H9.29297C9.50391 14 9.75 13.7891 9.75 13.5781V11.082C9.75 10.8711 9.50391 10.625 9.29297 10.625H7.92188C7.71094 10.625 7.5 10.8711 7.5 11.082V13.5781C7.5 13.7891 7.71094 14 7.92188 14ZM11.2969 14H12.668C12.8789 14 13.125 13.7891 13.125 13.5781V6.58203C13.125 6.37109 12.8789 6.125 12.668 6.125H11.2969C11.0859 6.125 10.875 6.37109 10.875 6.58203V13.5781C10.875 13.7891 11.0859 14 11.2969 14ZM20.4375 16.25H5.25V5.5625C5.25 5.28125 4.96875 5 4.6875 5H3.5625C3.24609 5 3 5.28125 3 5.5625V17.375C3 18.0078 3.49219 18.5 4.125 18.5H20.4375C20.7188 18.5 21 18.2539 21 17.9375V16.8125C21 16.5312 20.7188 16.25 20.4375 16.25Z" })
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "pl-10p" }, "Bản đồ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconComponent = _resolveComponent("IconComponent")
  const _component_InputComponent = _resolveComponent("InputComponent")
  const _component_TooltipComponent = _resolveComponent("TooltipComponent")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_InputComponent, {
        class: "flex-grow pr-10p",
        modelValue: _ctx.searchValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchValue = $event)),
        onKeyup: _withKeys(_ctx.getData, ["enter"]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShow = true)),
        closeIcon: "",
        placeholder: "Nhập tên vị trí..."
      }, {
        prefix: _withId(() => [
          _createVNode(_component_IconComponent, { name: "search" })
        ]),
        _: 1
      }, 8, ["modelValue", "onKeyup"]),
      (_ctx.places.length > 0 && _ctx.isShow)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("ul", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.places, (item, i) => {
                return (_openBlock(), _createBlock("li", {
                  class: "cursor-pointer py-8p px-12p rounded hover:bg-neutrals-100",
                  key: i,
                  onClick: _withModifiers(($event: any) => (_ctx.onChangeSelect(item)), ["stop","prevent"])
                }, [
                  _createVNode("span", _hoisted_4, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("div", _hoisted_6, [
                        _createVNode(_component_TooltipComponent, {
                          content: 
                      item.zone ? item.name + ' - ' + item.zone.name : item.name
                    ,
                          showByTruncate: "",
                          position: "top",
                          type: "light"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_7, _toDisplayString(item.zone
                          ? item.name + " - " + item.zone.name
                          : item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["content"])
                      ])
                    ])
                  ])
                ], 8, ["onClick"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", {
        class: [[_ctx.menuActive === 0 ? 'active-menu' : ''], "hover:bg-error-4 nav-item px-20p h-full flex items-center cursor-pointer"],
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.menuActive = 0))
      }, [
        _hoisted_9,
        _createVNode("span", {
          class: "pl-10p",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickOpenHome && _ctx.onClickOpenHome(...args)))
        }, "Trang chủ")
      ], 2),
      _createVNode("div", {
        class: [[_ctx.menuActive === 1 ? 'active-menu' : ''], "hover:bg-error-4 nav-item px-20p h-full flex items-center cursor-pointer"],
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.menuActive = 1))
      }, [
        _hoisted_10,
        _hoisted_11
      ], 2)
    ])
  ]))
})